<template>
  <div class="p-3">
    <h4 class="header-title mt-0 mb-1">{{ $t('industry.form.information') }} </h4>
    <p class="sub-header"></p>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="" class="form-label">{{ $t('industry.form.name.label') }}</label>
          <input 
            type="text" 
            readonly="" 
            class="form-control-plaintext"
            v-model="model.name"
          >
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    industryID() {
      let parameters = this.parameters || {}
      return parameters.industryID
    }
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.industryID

      this.$store.dispatch('industry/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    industryID: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.industryID) {
      this.fetchData()
    }
  }
}
</script>